// extracted by css-extract-rspack-plugin
export default {"reactionToggleButton":"ReactionButton-module__reactionToggleButton__AXSSeqz","reactionToggleButtonReacted":"ReactionButton-module__reactionToggleButtonReacted__Db08lM5"};